import { useCallback } from 'react'

import { getSignupErrorMessage } from '@/app/module/auth/helpers'
import { createNotification } from '@/app/module/notifications/store/actions'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export type SignupEmailValues = { email: string; verifyToken: string }

export const useSignupEmail = () => {
  const dispatch = useAppDispatch()
  const [signupEmail, res] = esApi.endpoints.authSignupEmail.useMutation()

  const signup = useCallback(
    async (values: SignupEmailValues) => {
      try {
        await signupEmail({ body: { email: values.email, verify_token: values.verifyToken } }).unwrap()
        return true
      } catch (error) {
        dispatch(
          createNotification({ 'signup-email-failure': { type: 'error', message: getSignupErrorMessage(error) } }),
        )
        return false
      }
    },
    [dispatch, signupEmail],
  )

  return [signup, res] as const
}
